import axios from 'axios';
import { useState } from "react"
import { useNavigate } from 'react-router-dom';
export default function BackMethods() {
    const governorates = [
        "دمشق", "ريف دمشق", "حلب", "حمص", "حماة", "اللاذقية", "طرطوس", "إدلب", "دير الزور", "الرقة", "الحسكة", "السويداء", "درعا", "القنيطرة"
    ]

    const UserTypes = [
        { id: 1, name: "موبايل" },
        { id: 2, name: "ويب" }
    ];
    const navigate = useNavigate();
    // const serverUrl = '/api'

    const serverUrl = 'https://custpro.gov.sy/api/'

    // const serverUrl = 'http://185.216.132.238:80/api/'
    // const serverUrl = 'http://localhost:80/api/'

    const getToken = () => {
        const tokenString = localStorage.getItem('token');
        const userToken = JSON.parse(tokenString);
        return userToken;
    }

    // get loged in user informaiton
    const getUser = () => {
        const userString = localStorage.getItem('user');
        const user_detail = JSON.parse(userString);
        return user_detail;
    }


    const getMustChangePassword = () => {
        const tokenString = localStorage.getItem('mustChangePassword');
        const userToken = JSON.parse(tokenString);
        return userToken;
    }
    const getRefreshToken = () => {
        const tokenString = localStorage.getItem('refreshToken');
        const userToken = JSON.parse(tokenString);
        return userToken;
    }

    const [token, setToken] = useState(getToken());
    const [user, setUser] = useState(getUser());

    const [mustChangePassword, setMustChangePassword] = useState(getMustChangePassword());
    const [refreshToken, setRefreshToken] = useState(getRefreshToken());

    // save token to session
    const saveToken = (data) => {
        // حفظ مباشرة من response
        localStorage.setItem('token', JSON.stringify(data.token));
        localStorage.setItem('user', JSON.stringify(data.user || {}));
        localStorage.setItem('mustChangePassword', JSON.stringify(data.mustChangePassword || false));
        localStorage.setItem('refreshToken', JSON.stringify(data.refreshToken || null));
        // تحديث الstates
        setToken(data.token);
        setUser(data.user || {});
        setMustChangePassword(data.mustChangePassword || false);
        setRefreshToken(data.refreshToken || null);
        navigate('/admin');
    };



    // logout user and clear session information
    const logout = () => {
        localStorage.clear();
        sessionStorage.clear();
        setToken(undefined);
    }


    // create axios request object
    const backEnd_request = axios.create({
        baseURL: serverUrl,

        headers: {
            'Content-Type': 'application/json',
            // 'Content-Type': 'multipart/form-data',

            'Authorization': `Bearer ${token}`
        }
    });


    // =================
    // Refresh Handling
    // =================
    let isRefreshing = false;
    let pendingRequests = [];

    backEnd_request.interceptors.response.use(
        (response) => response,
        async (error) => {
            const originalRequest = error.config;

            // إذا التوكن منتهي
            if (error.response?.status === 401 && !originalRequest._retry) {
                if (isRefreshing) {
                    // إذا هناك طلبات تنتظر التوكن الجديد
                    return new Promise((resolve) => {
                        pendingRequests.push((newToken) => {
                            originalRequest.headers.Authorization = "Bearer " + newToken;
                            resolve(backEnd_request(originalRequest));
                        });
                    });
                }

                originalRequest._retry = true;
                isRefreshing = true;

                try {
                    const refreshToken = localStorage.getItem("refresh_token");

                    const res = await axios.post(`${serverUrl}/refresh`, {
                        refresh_token: refreshToken,
                    });

                    const newAccessToken = res.data.access_token;
                    localStorage.setItem("access_token", newAccessToken);

                    pendingRequests.forEach((cb) => cb(newAccessToken));
                    pendingRequests = [];
                    isRefreshing = false;

                    originalRequest.headers.Authorization = "Bearer " + newAccessToken;
                    return backEnd_request(originalRequest);
                } catch (err) {
                    isRefreshing = false;
                    pendingRequests = [];
                    window.location.href = "/admin/login";
                    return Promise.reject(err);
                }
            }

            return Promise.reject(error);
        }
    );


    const checkUserLogin = () => {
        console.log(token);
        if (token == undefined) {
            navigate('/login');
            return false;
        }
        return true;
    }
    const UserAvatar = () => (
        <div className="nav-link container btn  rounded-circle  " onClick={() => (console.log(''))}>
            <img src={'http://192.168.43.107:8000/images/' + user.image} alt="avatar"
                class="rounded-circle d-flex align-self-start  shadow-1-strong package-item"
                style={{ maxWidth: '55px', boxShadow: " 1px 1px 1px 1px  " }} />
        </div>

    )





    // const notifyAddedToCart = (item) => toast.success(`${item.name} added to cart!`, {
    //     position: "top-center",
    //     autoClose: 2000,
    //     hideProgressBar: true,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     theme: 'colored',
    //     style: {
    //         backgroundColor: '#fff',
    //         color: '#000',
    //     }
    // });

    // const notifyRemovedFromCart = (item) => toast.error(`${item.name} removed from cart!`, {
    //     position: "top-center",
    //     autoClose: 2000,
    //     hideProgressBar: true,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     theme: 'colored',
    //     style: {
    //         backgroundColor: '#000',
    //         color: '#fff',
    //     }
    // });

    return {
        governorates, UserTypes,
        setToken: saveToken, serverUrl,
        token,
        user,
        getToken,
        getUser,
        backEnd_request,
        logout,
        checkUserLogin,
    };
}